
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {channelGroupList, channelTypeList} from '@divvit/common-channels'
import Select from './Select'
import propsChanged from 'utils/propsChanged'
import classnames from 'classnames'

export default class ChannelSelect extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    onSelect: PropTypes.func,
    onChannelSelect: PropTypes.func,
    onGroupSelect: PropTypes.func,
    onTypeSelect: PropTypes.func,
    value: PropTypes.shape({
      channelType: PropTypes.string,
      channelGroup: PropTypes.string,
      channel: PropTypes.string
    }),
    availableChannels: PropTypes.object
  }

  state = {
    selectedType: null,
    selectedGroup: null,
    selectedChannel: null
  }

  componentWillReceiveProps(nextProps) {
    if (propsChanged(this.props, nextProps, ['value', 'availableChannels'])) {
      const {value} = nextProps
      if (!value) {
        this.setState({
          selectedType: null,
          selectedGroup: null,
          selectedChannel: null
        })
      } else {
        this.setState(value)
      }
    }
  }

  render() {
    const {className} = this.props
    const {selectedType, selectedGroup, selectedChannel} = this.state
    const classNames = classnames('channel-select', className)
    return (
      <div className={classNames} onClick={this.onClick}>
        <Select
          className='channel-select_groups'
          value={selectedGroup}
          options={this.getGroups()}
          empty='Select group'
          onSelect={this.onGroupSelect}
        />
        <Select
          className='channel-select_channels'
          value={selectedChannel}
          options={this.getFilteredChannels()}
          empty='Select channel'
          disabled={!selectedGroup}
          onSelect={this.onChannelSelect}
          withIcon
        />
        <br />
        <Select
          className='channel-select_types'
          value={selectedType}
          options={this.getTypes()}
          empty='Select type'
          onSelect={this.onTypeSelect}
          isChannelType
        />
      </div>
    )
  }

  onTypeSelect = item => {
    const {onTypeSelect, onSelect} = this.props
    const value = item ? item.id : null

    this.setState({
      selectedType: value
    })

    const changedValue = {
      channelTypeId: value,
      channelGroupId: this.state.selectedGroup,
      channelId: this.state.selectedChannel
    }

    onTypeSelect && onTypeSelect(changedValue)
    onSelect && onSelect(changedValue)
  }

  onGroupSelect = item => {
    const {onSelect, onGroupSelect, onChannelSelect} = this.props
    const {selectedChannel} = this.state
    const value = item ? item.id : null
    const channelChanged = !!selectedChannel
    this.setState({
      selectedGroup: value,
      selectedChannel: null
    })

    const changedValue = {
      channelTypeId: this.state.selectedType,
      channelGroupId: value,
      channelId: null
    }
    onGroupSelect && onGroupSelect(changedValue)
    if (channelChanged) {
      onChannelSelect && onChannelSelect(changedValue)
    }
    onSelect && onSelect(changedValue)
  }

  onChannelSelect = item => {
    const {onChannelSelect, onSelect} = this.props
    const value = item ? item.id : null

    this.setState({
      selectedChannel: value
    })

    const changedValue = {
      channelTypeId: this.state.selectedType,
      channelGroupId: this.state.selectedGroup,
      channelId: value
    }
    onChannelSelect && onChannelSelect(changedValue)
    onSelect && onSelect(changedValue)
  }

  getTypes() {
    const {selectedGroup} = this.state
    if (!selectedGroup) {
      return channelTypeList.filter(item => !!item.id)
    }

    const channelGroup = channelGroupList.find(item => item.id === selectedGroup)
    return channelGroup?.channelTypes || []
  }

  getGroups() {
    const {availableChannels} = this.props
    if (!availableChannels) return channelGroupList
    const {groups: activeGroups} = availableChannels

    return channelGroupList.map(channelGroup => {
      return {
        ...channelGroup,
        disabled: !activeGroups.includes(channelGroup.id)
      }
    })
  }

  getFilteredChannels() {
    const {channels: activeChannels = []} = this.props.availableChannels || {}
    const {selectedGroup} = this.state
    if (!selectedGroup) return null
    const channelGroup = channelGroupList.find(
      channelGroup => channelGroup.id === selectedGroup
    )
    if (!channelGroup) return null

    const channels = (channelGroup || {}).channels

    return channels
      .filter(ch => ch.id !== 'prisjakt')
      .map(channel => {
        return {
          ...channel,
          disabled: activeChannels.length
            ? !activeChannels.includes(`${selectedGroup}/${channel.id}`)
            : false
        }
      })
  }
}



// WEBPACK FOOTER //
// ./client/components/ChannelSelect/index.js